import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { markupInitialState } from './markup.constant';
import { MarkupAction } from './markup.action';
import { makeMarkupSymbolCompositeId } from './_helpers/makeMarkupSymbolCompositeId';
import type { IMarkupStore } from './markup.interface';

export const markupReducer = reducerWithInitialState(markupInitialState)
  .case(MarkupAction.loadList.started, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Started,
    };
  })
  .case(MarkupAction.loadList.done, (state, { result }): IMarkupStore => {
    const { totalCount, filteredCount } = result;

    return {
      ...state,
      totalCount,
      filteredCount,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(MarkupAction.loadList.failed, (state) => {
    return {
      ...state,
      networkStatus: NetworkStatus.Failed,
    };
  })
  .case(MarkupAction.load.started, (state, params) => {
    const id = makeMarkupSymbolCompositeId(params.profileId, params.coreSymbolId);

    return {
      ...state,
      data: {
        ...state.data,
        [id]: {
          ...state.data[id],
          networkStatus: NetworkStatus.Started,
        },
      },
    };
  })
  .case(MarkupAction.load.done, (state, { params, result }) => {
    const id = makeMarkupSymbolCompositeId(params.profileId, params.coreSymbolId);

    return {
      ...state,
      data: {
        ...state.data,
        [id]: {
          ...state.data[id],
          ...result,
          networkStatus: NetworkStatus.Done,
        },
      },
    };
  })
  .case(MarkupAction.load.failed, (state, { params }) => {
    const id = makeMarkupSymbolCompositeId(params.profileId, params.coreSymbolId);

    return {
      ...state,
      data: {
        ...state.data,
        [id]: {
          ...state.data[id],
          networkStatus: NetworkStatus.Failed,
        },
      },
    };
  })
  .case(MarkupAction.update.done, (state, { params }) => {
    const id = makeMarkupSymbolCompositeId(params.profileId, params.markup.symbolId);

    return {
      ...state,
      data: {
        ...state.data,
        [id]: {
          ...state.data[id],
          ...params.markup,
          networkStatus: NetworkStatus.Done,
        },
      },
    };
  })
  .case(MarkupAction.destroy, () => ({
    ...markupInitialState,
  }));
